import React from 'react'
import { Box, Grid, Heading } from '@chakra-ui/react'
import { StockData } from '../types'
import { formatCurrency, formatNumber } from '../utils'
import StatCard from './StatCard'

interface FinancialsPanelProps {
  data: StockData
  gridTemplateColumns: number | undefined
  statCardBg: string
}

const FinancialsPanel: React.FC<FinancialsPanelProps> = ({
  data,
  gridTemplateColumns,
  statCardBg
}) => {
  return (
    <Box>
      <Heading as="h3" mb={4} size="md">Financial Data</Heading>
      <Grid gap={4} templateColumns={`repeat(${gridTemplateColumns || 2}, 1fr)`}>
        <StatCard
          bg={statCardBg}
          label="Revenue"
          value={formatCurrency(data.financials.revenue)}
        />
        <StatCard
          bg={statCardBg}
          label="Gross Profit"
          value={formatCurrency(data.financials.grossProfit)}
        />
        <StatCard
          bg={statCardBg}
          label="Operating Income"
          value={formatCurrency(data.financials.operatingIncome)}
        />
        <StatCard
          bg={statCardBg}
          label="Net Income"
          value={formatCurrency(data.financials.netIncome)}
        />
        <StatCard
          bg={statCardBg}
          label="Cash Flow"
          value={formatCurrency(data.financials.cashFlow)}
        />
        <StatCard
          bg={statCardBg}
          label="Cash"
          value={formatCurrency(data.financials.cash)}
        />
        <StatCard
          bg={statCardBg}
          label="Debt"
          value={formatCurrency(data.financials.debt)}
        />
        <StatCard
          bg={statCardBg}
          label="Assets"
          value={formatCurrency(data.financials.assets)}
        />
        <StatCard
          bg={statCardBg}
          label="Liabilities"
          value={formatCurrency(data.financials.liabilities)}
        />
        <StatCard
          bg={statCardBg}
          label="Shares Outstanding"
          value={formatNumber(data.financials.sharesOutstanding)}
        />
      </Grid>
    </Box>
  )
}

export default FinancialsPanel
